import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Message from 'supportAssistant/components/Chat/Message'
import MessagesLoadingSkeleton from './MessagesLoadingSkeleton'
import BodyText from 'LuxKit/Typography/BodyText'
import moment from 'moment/moment'
import Loading from 'components/Common/Loading/LoadingAnimation'
import Group from 'components/utils/Group'

const WAITING_MESSAGE_DELAY = 8000

const StyledDateBodyText = styled(BodyText)`
 margin-bottom: ${rem(24)};
 margin-top: ${rem(24)};
`

const StyledTimeBodyText = styled(BodyText)`
  margin-left: ${rem(34)};
  margin-bottom: ${rem(8)};
`

const MessageContent = styled.div`
  padding: ${rem(8)};
  border-radius: ${rem(4)};
  background-color: ${props => props.theme.palette.neutral.default.seven};
  color: ${props => props.theme.palette.neutral.default.one};
  width: max-content;
`

const MessageLoadingWrapper = styled(MessageContent)`
  margin-top: ${rem(24)};
`

interface Props {
  messages: Array<App.ChatMessage>;
  loadingMessages?: boolean;
  isTyping: boolean;
  isAgentTyping: boolean;
}

function MessagesListContainer(props: Props) {
  const { messages, loadingMessages, isTyping, isAgentTyping } = props

  const [isTypingGtWait, setIsTypingGtWait] = useState(false)

  // Epoch date 1970, so first message will always be different and therefore display date/time
  let previousDate = moment(0).format('D MMMM YYYY')

  // if isTyping has been true for longer than 5 seconds show text
  useEffect(() => {
    if (isTyping) {
      const timeout = setTimeout(() => {
        setIsTypingGtWait(true)
      }, WAITING_MESSAGE_DELAY)
      return () => clearTimeout(timeout)
    } else {
      setIsTypingGtWait(false)
    }
  }, [isTyping])

  return (
    <Group direction="vertical" gap={16} fullWidth>
      {loadingMessages && <MessagesLoadingSkeleton />}
      {!loadingMessages && <>
        {messages?.map((message, index) => {
          const messageDate = moment(message.createdAt).format('D MMMM YYYY')

          if (messageDate !== previousDate) {
            previousDate = messageDate

            return (
              <Fragment key={`${index}`}>
                <StyledDateBodyText variant="small" align="center">
                  {previousDate}
                </StyledDateBodyText>
                {index === 0 && <StyledTimeBodyText variant="small">{moment(message.createdAt).format('HH:mma')}</StyledTimeBodyText>}
                <Message
                  message={message}
                  key={`${message.createdAt}-${index}`}
                />
              </Fragment>
            )
          }

          return (
            <Message
              message={message}
              key={`${message.createdAt}-${index}`}
            />
          )
        })}
      </>}
      {isTypingGtWait &&
        <Message
          message={{
            sender: 'chatbot',
            text: 'We’re searching for a response to your question, thank you for your patience',
          }}
        />
      }
      {(isTyping || isAgentTyping) && <MessageLoadingWrapper><Loading size={6} /></MessageLoadingWrapper>}
    </Group>
  )
}

export default MessagesListContainer
